<!--<div-->
<!--  class="panel rs-flex-row rs-border-promo"-->
<!--  *ngIf="isLocalhost()"-->
<!--  style="position: absolute; z-index: 100; top: 0"-->
<!--&gt;-->
<!--  <div class="rs-flex-row rs-flex-bottom">-->
<!--    <div class="rs-flex-columns">-->
<!--      <label class="rs-txt-promo" for="serviceId">DEV MODE ONLY - PII serviceId</label>-->
<!--      <select id="serviceId" [(ngModel)]="serviceId" style="width: 200px">-->
<!--        <option value="024278209">TV - 024278209</option>-->
<!--        <option value="G98070000">Cloud 1TB - G98070000</option>-->
<!--        <option value="G98079899">Cloud 10 GB - G98079899</option>-->
<!--        <option value="0470241245">MV 0470241245</option>-->
<!--        <option value="0498127445">MV 0498127445</option>-->
<!--        <option [value]="undefined">No serviceId</option>-->
<!--        <option value="101636694572">internet Maxi - 101636694572</option>-->
<!--      </select>-->
<!--    </div>-->
<!--    <div class="rs-flex-columns">-->
<!--      <button class="rs-btn" (click)="saveServiceId()">Set and refresh page</button>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<section data-tms-spa>
  <router-outlet pxAnalyticsNavigation></router-outlet>
  <px-modal-placeholder></px-modal-placeholder>
</section>
